/**
 * Shared Components i18n
 * Centralized locale management for all shared components
 */

import { setLocale as setAIGeneratorLocale, getLocale as getAIGeneratorLocale } from '../components/ai-generator/i18n';
import { setLocale as setH5PLocale, getLocale as getH5PLocale } from '../components/h5p/i18n';
import { setLocale as setACHLocale, getLocale as getACHLocale } from '../components/ach/i18n';

export type SupportedLocale = 'en' | 'vi';

/**
 * Set locale for all shared components at once
 */
export function setSharedComponentsLocale(locale: SupportedLocale): void {
  setAIGeneratorLocale(locale);
  setH5PLocale(locale);
  setACHLocale(locale);
}

/**
 * Get the current locale (from AIGenerator as the reference)
 */
export function getSharedComponentsLocale(): string {
  return getAIGeneratorLocale();
}

// Re-export individual setLocale functions for fine-grained control
export {
  setAIGeneratorLocale,
  getAIGeneratorLocale,
  setH5PLocale,
  getH5PLocale,
  setACHLocale,
  getACHLocale,
};
